import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardGrid from 'UIComponents/card/UICardGrid';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import SplashPageCard from './SplashPageCard';
import { Container, Section, SectionHeader, SectionSubTitle, SectionTitle } from './SplashPageSharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductsSection = ({
  selectedTab,
  sectionProps
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const productLines = [...AllProductLines, COMMERCE];
  const productLineTiles = useAppSelector(state => productLines.map(productLine => {
    const navItem = navItemForProductLineSelector(state, productLine);
    const path = isAppAuth || productLine === 'COMMERCE' ? `/${navItem}` : `/${navItem}/${selectedTab}`;
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.products.${productLine}.title`,
      descriptionKey: `splash-page.products.${productLine}.description.${selectedTab}`,
      pathname: path,
      showIcon: true,
      productLine: productLine
    }, productLine);
  }));
  return /*#__PURE__*/_jsx(Section, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.products.subtitle.${selectedTab}`
          })
        })]
      }), /*#__PURE__*/_jsx(UICardGrid, {
        children: productLineTiles
      })]
    })
  }));
};
export default ProductsSection;